function getCarouselInstance(element) {
  if (!window.$hsCarouselCollection) {
    return null;
  }

  return window.HSCarousel?.getInstance?.(element);
}

function setControlsVisibility(element, slideCount) {
  if (slideCount > 1) {
    return;
  }

  element.querySelector(".hs-carousel-prev")?.classList.add("hidden");
  element.querySelector(".hs-carousel-next")?.classList.add("hidden");
  element.querySelector(".hs-carousel-pagination")?.classList.add("hidden");
}

export function getActiveCarouselImage(element) {
  return (
    element.querySelector(".hs-carousel-slide.active img[id]") ||
    element.querySelector(".hs-carousel-slide img[id]")
  );
}

export function removeCarouselImage(element, imageId) {
  const image = Array.from(element.querySelectorAll(".hs-carousel-slide img")).find(
    (candidate) => candidate.id === String(imageId),
  );
  const slide = image?.closest(".hs-carousel-slide");

  if (!slide) {
    return null;
  }

  const carouselInstance = getCarouselInstance(element);

  slide.remove();

  const slides = Array.from(element.querySelectorAll(".hs-carousel-slide"));
  setControlsVisibility(element, slides.length);

  if (slides.length === 0) {
    return 0;
  }

  if (!carouselInstance) {
    window.HSCarousel?.autoInit?.();
    return slides.length;
  }

  carouselInstance.slides = slides;
  carouselInstance.currentIndex = Math.min(carouselInstance.currentIndex, slides.length - 1);
  carouselInstance.initDots();
  carouselInstance.recalculateWidth();

  return slides.length;
}
